import React from "react";

// import img1 from "../../images/placeholder-fake.png";
import img1 from "../../images/placeholder-home (1).png";
import img2 from "../../images/placeholder-home (2).png";
import img3 from "../../images/placeholder-home (3).png";
import "./HomeRightSection.css";
import {ReactComponent as LeftArrow} from "../../icons/arrow-left-bold.svg";
import {ReactComponent as RightArrow} from "../../icons/arrow-right-bold.svg";
import {FaCircle as Circle} from "react-icons/fa";

export default class HomeRightSection extends React.Component {
  state = {
    activeIndex: 0,
    show: true,
    slides: [
      <img className="slide" src={img1} />,
      <img className="slide" src={img2} />,
      <img className="slide" src={img3} />,
    ],
    texts: [
      'Porta nuovi clienti su Farmakom e offri le tue competenze alle farmacie che hanno bisogno di crescere.',
      'Offri ai tuoi clienti una soluzione affidabile, personalizzabile e intuitiva per gestire e far crescere la loro farmacia',
      'Una farmacia su 2 cambia piattaforma eCommerce dopo il primo anno a causa dell’inadeguatezza e della mancata integrazione con l’ecosistema farmacia'
    ]
  };

  _handleChangeActiveIndex = (delta) => {
    setTimeout(() => {
      if (this.state.activeIndex === 0 && delta < 0) {
        this.setState({
          activeIndex: this.state.slides.length - 1,
        });
      } else if (
        this.state.activeIndex === this.state.slides.length - 1 &&
        delta > 0
      ) {
        this.setState({
          activeIndex: 0,
        });
      } else {
        this.setState({
          activeIndex: this.state.activeIndex + delta,
        });
      }
    }, 400)
    

    this.setState({
      show: false,
    });
    setTimeout(() => this.setState({ show: true }), 800);
  };

  render() {
    const { activeIndex } = this.state;
    return (
      <div className="home-right-container">
        <div className="home-right-preview-container">
          <Slider
            data={this.state.slides}
            show={this.state.show}
            activeIndex={activeIndex}
          />
        </div>
        <div className="home-right-slider-container">
          <div className="slider-left-section">
            <div className="slider-left-counter">
              {this.state.slides.map((slide, idx) => (
                <Circle
                  key={idx}
                  className={idx === activeIndex ? "active counter" : "counter"}
                />
              ))}
            </div>
            <p style={{fontWeight: 'bold', fontSize: '1.2vw', lineHeight: '1.8vw'}}>{this.state.texts[activeIndex]}</p>
          </div>
          <div className="slider-right-container">
            <div
              className="slider-arrow-container"
              onClick={() => this._handleChangeActiveIndex(-1)}
            >
              <LeftArrow />
            </div>
            <div
              className="slider-arrow-container"
              onClick={() => this._handleChangeActiveIndex(1)}
            >
              <RightArrow />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Slider = (props) => {
  const { activeIndex, show, data } = props;
  const current = data[activeIndex];
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        zIndex: 3,
      }}
      className={show === false ? "change" : ""}
    >
      {current}
    </div>
  );
};
